import React from 'react';
import ReactDOM from 'react-dom';

export class ModalWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.modalRoot = props.modalRoot;
        this.wrapperElem = document.createElement('section');
        this.wrapperElem.setAttribute('class', 'modalWrapper');
        this.wrapperElem.setAttribute('aria-hidden', 'true');
        this.$docContainer = $j('#contentBody');
        this.modalOpenClassName = 'modal-open';
    }

    componentDidMount() {
        this.modalRoot.appendChild(this.wrapperElem);
        if (!this.$docContainer.hasClass(this.modalOpenClassName)) this.$docContainer.addClass(this.modalOpenClassName);
    }

    componentWillUnmount() {
        this.modalRoot.removeChild(this.wrapperElem);
        if (this.$docContainer.hasClass(this.modalOpenClassName)) this.$docContainer.removeClass(this.modalOpenClassName);
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.wrapperElem,
        );
    }
}